<template>
  <v-container fluid>
    <v-row>
      <v-col xs="12" md="12" sm="12">
        <v-card>
          <v-card-title>
            <v-tabs grow>
              <v-tabs-slider color="green" />

              <v-tab @click="reportMode = 'groupByProjects'">
                По проектам
              </v-tab>

              <v-tab @click="reportMode = 'groupByQueues'">
                По очередям
              </v-tab>
            </v-tabs>

          </v-card-title>

          <v-form ref="form" lazy-validation v-model="formRules.valid">
            <v-card-text>
              <v-row>
                <v-col xs="12" sm="6" md="4" lg="4" xl="4">
                  <Carusel-Button class="mt-4" :getVal="getValDate" />
                </v-col>

                <v-col xs="12" sm="6" md="4" lg="4" xl="4" align="right">
                  <Project-Selector v-model="projects" />
                </v-col>


                <v-col xs="12" sm="12" md="4" lg="4" align="right">
                  <v-btn
                    color="info"
                    class="mt-3 mr-1"
                    :disabled="excelLoading"
                    @click="loadReport(true)"
                  >
                    <v-progress-circular
                      v-if="excelLoading"
                      indeterminate
                      color="success"
                    />
                    <span v-else>Excel</span>
                  </v-btn>

                  <v-btn
                    color="success"
                    class="mt-3"
                    @click="loadReport(false)"
                  >Поиск</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <v-card class="mt-5">
      <v-data-table
        :headers="report.headers"
        :items="report.items"
        :items-per-page="report.items.length"
        :loading="loading"
        loading-text="Загрузка..."
        no-data-text="Ничего не найдено"
        hide-default-footer
        class="bold-last-row"
      >

        <template #[`header.item_identifier`]>
          {{ reportMode === 'groupByProjects' ? 'Проект' : 'Очередь' }}
        </template>

        <template #[`item.avg_duration`]="{item}">
          {{ formatTime(item.avg_duration) }}
        </template>

        <template #[`item.avg_duration_min`]="{item}">
          {{ formatTime(item.avg_duration_min) }}
        </template>
      </v-data-table>
    </v-card>

  </v-container>

</template>

<style>

</style>

<script>
import moment from 'moment';

import {mapActions, mapGetters} from 'vuex';
import {requiredRule} from '~/plugins/rules';
import CaruselButton from '~/components/partials/CaruselButton.vue';
import ProjectSelector from '~/components/partials/selectors/ProjectSelector.vue';

export default {
  name: 'ByDays',
  components: {
    CaruselButton,
    ProjectSelector,
  },

  data() {
    return {
      reportMode: 'groupByProjects',
      formRules: {
        valid: false,
        required: requiredRule,
      },
      report: {
        headers: [
          {text: 'День', value: 'day'},
          {text: 'Очередь', value: 'item_identifier'},
          {text: 'Кол-во звонков', value: 'calls_count'},
          {text: 'Кол-во пропущенных', value: 'calls_count_abandon'},
          {text: 'Кол-во отвеченных', value: 'calls_count_answer'},
          {text: 'Кол-во пропущенных < порогового времени', value: 'calls_count_abandon_less_wait_time'},
          {text: 'Кол-во пропущенных > порогового времени', value: 'calls_count_abandon_more_wait_time'},
          {text: 'Средняя длительность разговора', value: 'avg_duration'},
          {text: 'Средняя длительность разговора (поминутно)', value: 'avg_duration_min'},
          {text: '% пропущенных > порогового времени', value: 'percent_calls_count_abandon_more_wait_time'},
          {text: 'Принятые + пропущенные > порогового времени', value: 'calls_count_answer_and_abandon_less_wait_time'},
        ],
        items: [],
      },

      date: 'current_month',
      projects: [],
      excelLoading: false,
    }
  },

  computed: {
    ...mapGetters({
      loading: 'shared/getLoading',
    }),

    payload() {
      return {
        projects: this.projects,
        period: this.date,
        group_by_projects: this.reportMode === 'groupByProjects',
      }
    },
  },

  methods: {
    ...mapActions({
      loadByDaysItems: 'by_days/loadByDaysItems',
      resetAllState: 'resetAllState',
    }),

    formatTime(secs) {
      if (!secs) return;

      return moment.utc(secs * 1000).format('HH:mm:ss');
    },

    getValDate(data) {
      this.date = [
        moment(data.start).format('YYYY-MM-DD HH:mm:ss'),
        moment(data.end).format('YYYY-MM-DD HH:mm:ss')
      ]
    },

    async loadReport(excel = false) {
      if (!this.$refs.form.validate()) return

      if (excel) {
        this.excelLoading = true
        this.payload.excel = true;
      } else delete(this.payload.excel);

      await this.loadByDaysItems(this.payload)
        .then(response => {
          if (!excel) this.report.items = response.data;
        });

      this.excelLoading = false
    },

  },

  mounted() {
    // this.loadProjects({with: 'queues, tags'});
  },

  beforeDestroy() {
    this.resetAllState();
  },
}
</script>

<style>
.bold-last-row tbody tr:last-of-type {
  font-weight: 900;
}
</style>
